import { ADD_DATA_USERS, GET_USERS_ATRIBUTE } from "@/api/users";
import querystring from "query-string";

const state = {
    list_users: [],
};

const mutations = {
    SET_LIST_USERS: (state, payload) => {
        state.list_users = payload;
    },
};

const actions = {
    GET_LIST_USERS: async ({ commit }, params) => {
        params = querystring.stringify(params);
        const resp = await GET_USERS_ATRIBUTE(params);
        const data = resp.data.data;
        commit("SET_LIST_USERS", data);
    },

    CREATE_DATA: async ({ commit }, args) => {
        return await ADD_DATA_USERS(args);
    },
};

const getters = {
    listUsers: (state) => state.list_users,
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};